import {
  Typography,
  TextField,
  Box,
  Button,
  Radio,
  Select,
  MenuItem,
  InputLabel,
  FormHelperText,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Grid,
  FormLabel,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  TextareaAutosize
} from '@material-ui/core';
import ShowMore from 'react-show-more';
import { makeStyles } from '@material-ui/core/styles';

import { useForm, Controller } from 'react-hook-form';
import React from 'react';
import { Loading } from '../../Loading';
import Tooltip from '@material-ui/core/Tooltip';
import Info from '@jda/lui-common-icon-library/ui/Info';

const useStyles = makeStyles(theme => ({
  buttonMargin: {
    marginTop: theme.spacing(2),
    marginRight: theme.spacing(1)
  },
  formControlLabel: {
    '& > *': {
      fontWeight: 400,
      fontSize: '0.875rem'
    }
  },
  radioGroup: {
    display: 'inherit'
  },
  textFieldStyle: {
    width: '100%'
  },
  formControl: {
    width: '80%'
  },
  formControlFullWidth: {
    width: '100%'
  },
  sectionHeader: {
    paddingTop: theme.spacing(1)
  },
  tooltip: {
    opacity: 0.4,
    padding: 0,
    minWidth: '15px',
    top: '-3px',
    background: 'none'
  },
  fieldTooltip: {
    position: 'absolute',
    top: '18px',
    right: '-22px',
    minWidth: '20px',
    opacity: 0.4
  },
  textArea: {
    margin: '10px 0',
    fontFamily: 'inherit',
    fontSize: '0.875rem',
    lineHeight: '1.3rem'
  },
  showMore: {
    fontSize: '13px',
    color: '#646161',
    fontWeight: 'normal'
  }
}));

interface FormsMetaDataType {
  key: string;
  label: string;
  defaultValue?: any;
  type: string;
  rules?: object | any;
  values?: Array<any> | any;
  labelStyleType?: 'Typography' | 'InputLabel' | any;
  size?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 'auto';
  required?: true | false;
  disabled?: true | false;
  tooltip?: any;
  InputProps?: any;
  inputAdorment?: any;
  fullWidth?: any;
}

type FormPropsType = {
  dataConfig: any;
  handleDialogClose: any;
  handleDialogSubmit: any;
  submitlabel: string;
  title: string;
  dialogId: string;
  openFn: any;
  closeFn: any;
  children?: any;
  getLatestValues?: any;
  data?: any;
  loading?: true | false;
  handleStatusToggleChange?: any;
  existingDisable?: true | false;
  selectedKey?: true | false;
  supportUser?: true | false;
  maxWidth?: 'lg' | 'md' | 'sm';
  tooltip?: string;
  InputProps?: any;
  formError?: true | false;
  formErrorMsg?: any;
  disableSubmitButton?: true | false;
  caption?: any;
};

export const FieldInfo = (props: any) => (
  <Tooltip title={props.title} placement="top" className={props.className} interactive tabIndex={-1}>
    <Button>
      <Info fontSize="small" />
    </Button>
  </Tooltip>
);

export const DialogForm = (formProps: FormPropsType) => {
  const classes = useStyles();
  const { handleSubmit, getValues, control, errors } = useForm();
  const renderTextField = (props: FormsMetaDataType, role: any) => {
    return (
      <>
        <Controller
          inputProps={{ 'aria-label': props.label }}
          id={props.key}
          as={TextField}
          className={classes.textFieldStyle}
          type={props.type}
          name={props.key}
          required={props.required}
          label={props.label}
          defaultValue={props.defaultValue}
          control={control}
          rules={props.rules}
          error={(errors && errors[props.key]?.message) || false}
          disabled={role ? role : props.disabled}
          InputProps={
            props &&
            props.inputAdorment && {
              endAdornment: '@'
            }
          }
        />
        {props.tooltip && <FieldInfo title={props.tooltip} className={classes.fieldTooltip} />}
      </>
    );
  };
  const renderTextArea = (props: FormsMetaDataType, role: any) => {
    return (
      <>
        <Controller
          as={
            <TextareaAutosize
              className={classes.textArea}
              disabled={role ? role : props.disabled}
              value={props.defaultValue}
              rowsMin={5}
              onClick={e => handleChange(e, props.key, 'textArea')}
            />
          }
          defaultValue={props.defaultValue}
          name={props.key}
          rules={props.rules}
          error={(errors && errors[props.key]?.message) || false}
          control={control}
        />
      </>
    );
  };

  const handleChange = (e: any, key: string, type: string) => {
    if (typeof formProps?.getLatestValues === 'function') {
      const values = getValues();
      if (type === 'radio') {
        values[key] = e.target.value;
      }
      formProps?.getLatestValues(values);
    }
  };

  const renderDropDown = (props: FormsMetaDataType, role: any) => {
    return (
      <>
        <Controller
          as={
            <Select
              label={props.label}
              disabled={role ? role : props.disabled}
              value={props.defaultValue}
              onClick={e => handleChange(e, props.key, 'dropDown')}
            >
              {props.values?.map((item: any) => [<MenuItem value={item.value}>{item.label}</MenuItem>])}
            </Select>
          }
          defaultValue={props.defaultValue}
          name={props.key}
          rules={props.rules}
          error={(errors && errors[props.key]?.message) || false}
          control={control}
        />
        {props.tooltip && <FieldInfo title={props.tooltip} className={classes.fieldTooltip} />}
      </>
    );
  };

  // const renderCheckbox = (props: FormsMetaDataType) => {
  //   return (
  //     <Controller
  //       name={props.key}
  //       rules={props.rules}
  //       defaultValue={props.defaultValue}
  //       render={subProps =>
  //         props.values?.map((item: any, index: number) => (
  //           <FormControlLabel
  //             control={
  //               <Checkbox
  //                 color="primary"
  //                 onChange={() => subProps.onChange(handleCheck(props.key, item.value))}
  //                 defaultChecked={props.defaultValue.includes(item.value)}
  //               />
  //             }
  //             key={item.value}
  //             label={item.label}
  //             // className={classes.formControlLabel}
  //           />
  //         ))
  //       }
  //       control={control}
  //     />
  //   );
  // };

  const renderRadioButtons = (props: FormsMetaDataType, role: any) => {
    return (
      <Controller
        defaultValue={props.defaultValue}
        as={
          <div style={{ width: '100%' }}>
            <Box display="inline">
              <FormLabel>
                {props?.label}
                {props.tooltip && <FieldInfo title={props.tooltip} className={classes.tooltip} />}
              </FormLabel>
            </Box>
            <Box m={2} display="inline">
              <RadioGroup
                row
                className={classes.radioGroup}
                defaultValue={props.defaultValue}
                onClick={e => handleChange(e, props.key, 'radio')}
              >
                {props?.values?.map((item: any) => {
                  return (
                    <FormControlLabel
                      key={item.label}
                      value={item.value}
                      labelPlacement="end"
                      control={<Radio color="primary" />}
                      label={item.label}
                      className={classes.formControlLabel}
                      disabled={role ? role : props.disabled}
                    />
                  );
                })}
              </RadioGroup>
            </Box>
          </div>
        }
        rules={props.rules}
        name={props.key}
        control={control}
      />
    );
  };

  // const renderSlider = (props: any) => {
  //   return (
  //     <Controller
  //       defaultValue={props.defaultValue}
  //       render={subProps => (
  //         <Slider
  //           {...subProps}
  //           onChange={(_, value) => {
  //             subProps.onChange(value);
  //           }}
  //           valueLabelDisplay="auto"
  //           max={props.values.max}
  //           step={props.values.step}
  //         />
  //       )}
  //       name={props.key}
  //       rules={props.rules}
  //       error={(errors && errors[props.key]?.message) || false}
  //       control={control}
  //     />
  //   );
  // };

  // const renderDatePicker = (props: FormsMetaDataType) => {
  //   return (
  //     <Controller
  //       defaultValue={props.defaultValue}
  //       render={subProps => (
  //         <MuiPickersUtilsProvider utils={CustomDateFnsUtils}>
  //           <LuiDateRangePicker
  //             value={props.defaultValue}
  //             autoOk
  //             disableToolbar
  //             onChange={(value: any) => {
  //               subProps.onChange(value);
  //             }}
  //             variant="inline"
  //           />
  //         </MuiPickersUtilsProvider>
  //       )}
  //       name={props.key}
  //       rules={props.rules}
  //       error={(errors && errors[props.key]?.message) || false}
  //       control={control}
  //     />
  //   );
  // };

  const renderFormType = (props: FormsMetaDataType, data: any, role: any) => {
    const fieldType = props.type;
    if (data !== undefined && data[props.key] !== null) props.defaultValue = data[props.key];
    if (props.disabled) {
      props.required = false;
      if (props?.rules?.['required']) delete props?.rules?.required;
    }
    switch (fieldType) {
      case 'radio':
        return renderRadioButtons(props, role);
      // case 'checkbox':
      //   return renderCheckbox(props);
      case 'dropdown':
        return renderDropDown(props, role);
      // case 'slider':
      //   return renderSlider(props);
      // case 'date':
      //   return renderDatePicker(props);
      case 'hidden':
        return '';
      case 'sectionHeader':
        return renderSectionHeader(props);
      case 'textArea':
        return renderTextArea(props, role);
      default:
        return renderTextField(props, role);
    }
  };

  const renderSectionHeader = (props: FormsMetaDataType) => {
    return (
      <Typography variant="h3" className={classes.sectionHeader}>
        {props.label}
      </Typography>
    );
  };

  const renderTypographyLabel = (props: FormsMetaDataType) => {
    return (
      <Typography
        variant="inherit"
        color="textPrimary"
        style={{ color: '#3F4756BD' }}
        // className={classes.labelMargin}
      >
        {props.label}
      </Typography>
    );
  };

  const renderInputLabel = (props: FormsMetaDataType) => {
    return (
      <InputLabel error={(errors && errors[props.key]?.message) || false} shrink id={props.key}>
        {props.label}
      </InputLabel>
    );
  };

  const renderLabel = (props: any) => {
    const labelType = props?.labelStyleType || undefined;
    if (labelType) {
      return labelType === 'InputLabel' ? renderInputLabel(props) : renderTypographyLabel(props);
    }
    return '';
  };

  const renderErrorMessages = (props: FormsMetaDataType) => {
    return <FormHelperText error>{errors[props.key]?.message}</FormHelperText>;
  };

  const renderFormErrorMessages = (msg: any) => {
    return <FormHelperText error>{msg}</FormHelperText>;
  };

  return (
    <Dialog
      fullWidth={true}
      maxWidth={formProps.maxWidth || 'md'}
      open={formProps.openFn}
      onClose={formProps.closeFn}
      id={formProps.dialogId}
      key={formProps.dialogId}
      {...formProps}
    >
      <DialogTitle id="alert-dialog-title">
        {formProps.title}
        {formProps.tooltip && <FieldInfo title={formProps.tooltip} className={classes.tooltip} />}
        {formProps?.caption && (
          <span className={classes.showMore}>
            <ShowMore lines={3} more="Show more" less="Show less" anchorClass="">
              {formProps.caption}
            </ShowMore>
          </span>
        )}
      </DialogTitle>
      <DialogContent dividers>
        {formProps?.formError && !formProps?.loading ? renderFormErrorMessages(formProps?.formErrorMsg) : <div />}
        {(formProps?.loading ? (
          formProps.loading
        ) : (
          false
        )) ? (
          <Loading />
        ) : (
          <Grid container item xs={12} spacing={1}>
            {formProps?.dataConfig?.length > 0 &&
              formProps?.dataConfig?.map((item: FormsMetaDataType) => (
                <Grid key={item.key} item xs={item.size}>
                  <FormControl
                    key={item.key}
                    className={item?.fullWidth ? classes.formControlFullWidth : classes.formControl}
                  >
                    {renderLabel(item)}
                    {renderFormType(item, formProps.data, formProps?.supportUser)}
                    {errors && errors[item.key]?.message && renderErrorMessages(item)}
                  </FormControl>
                </Grid>
              ))}
          </Grid>
        )}
        {formProps.children}
      </DialogContent>
      <DialogActions>
        <div>
          {formProps.handleStatusToggleChange && formProps.existingDisable && !formProps.supportUser && (
            <Button
              data-id="Disable-Button"
              className={classes.buttonMargin}
              variant="outlined"
              color="primary"
              disableElevation
              onClick={formProps.handleStatusToggleChange}
              disabled={formProps?.disableSubmitButton ? false : true}
            >
              Disable
            </Button>
          )}
          <Button
            data-id="Cancel-Button"
            className={classes.buttonMargin}
            variant="outlined"
            color="primary"
            disableElevation
            onClick={formProps.handleDialogClose}
          >
            Cancel
          </Button>
          {!formProps.supportUser && (
            <Button
              className={classes.buttonMargin}
              data-id="handle-submit"
              onClick={handleSubmit(data => formProps.handleDialogSubmit(data))}
              type="submit"
              variant="contained"
              color="primary"
              disableElevation
            >
              {formProps.submitlabel}
            </Button>
          )}
        </div>
      </DialogActions>
    </Dialog>
  );
};
